import "./i18n";
import "./styles/App.css";
import "@mantine/dates/styles.css";
import { UIProvider } from "moh-ui";
import { RecoilRoot } from "recoil";
import AppRoutes from "./AppRoutes";
import * as Sentry from "@sentry/react";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./hooks/useAuth";
import CustomLink from "./components/common/CustomLink";
import { BrowserRouter as Router } from "react-router-dom";
import ErrorBoundary from "./components/HOCs/errorBoundary";
import { LanguageProvider } from "./contexts/LanguageContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: false,
    },
  },
});

function App() {
  return (
    <Sentry.ErrorBoundary>
      <ErrorBoundary>
        <RecoilRoot>
          <UIProvider LinkComponent={CustomLink}>
            <Toaster />
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <QueryClientProvider client={queryClient}>
                <LanguageProvider>
                  <AuthProvider>
                    <AppRoutes />
                  </AuthProvider>
                </LanguageProvider>
              </QueryClientProvider>
            </Router>
          </UIProvider>
        </RecoilRoot>
      </ErrorBoundary>
    </Sentry.ErrorBoundary>
  );
}

export default App;
